import React from 'react';
import { connect } from 'react-redux';

import FreeMember from '../../components/Home/Lawyer/Free/';
import Subscribed from '../../components/Home/Lawyer/Subscribed/';
import './Home.scss';
import { auth } from 'firebase';

function Home(props) {
  const {justifyContent, authClient, membership, suscription} = props;
  const user = {
    name: `${authClient.name} ${authClient.firstLastName} ${authClient.secondLastName}`,
    role: authClient.role,
    grade: '5.0',
    views: '1,638',
    opinions: '532',
    type_membership: 'gold',
    type_plan: 'mensual',
    plan_top: true,
    officeName: authClient.officeName? authClient.officeName: '',
  }
  //let typeOfMembership = 'other';
  return (
    <div style={{display:'flex', justifyContent , width:'100%'}}>
      {membership && membership.type && membership.type === 'Freemium' ? 
        (<FreeMember userData={user}  auth={authClient} />) :
        (<Subscribed userData={user} suscription={suscription}  auth={authClient}/>)}
    </div>
  );
}

const mapStateToProps = state => ({
  authClient : state.authClient,
  membership : state.authClient.membership,
})

export default connect(mapStateToProps)(Home)
